module.exports = __webpack_public_path__ + "static/media/03.6556d774.jpg";